/**
 * Created by karthik.ar on 24-05-2017.
 */
import { PipeTransform, Pipe } from '@angular/core';
@Pipe({
    name: 'datetimeformat',
    standalone: false
})
export class DateTimeFormatPipe implements PipeTransform {
  transform(milliSecs: any, type = 1) {
    // //console.log(milliSecs);
    const gameTime: Date = new Date(milliSecs);
    /*
     //console.log(gameTime);
     //console.log(gameTime.getFullYear());
     //console.log(gameTime.getMonth());
     //console.log(gameTime.getDate());
     //console.log(gameTime.getHours());
     //console.log(gameTime.getMinutes());
     //console.log(gameTime.getSeconds());
     //console.log(gameTime.getFullYear() + '_'
     + this.formatNum(gameTime.getMonth() + 1) + '_'
     + this.formatNum(gameTime.getDate()) + '_'
     + this.formatNum(gameTime.getHours()) + ':'
     + this.formatNum(gameTime.getMinutes()) + ':'
     + this.formatNum(gameTime.getSeconds()));*/
    return (
      gameTime.getFullYear() +
      '_' +
      this.formatNum(gameTime.getMonth() + 1) +
      '_' +
      this.formatNum(gameTime.getDate()) +
      '_' +
      this.formatNum(gameTime.getHours()) +
      ':' +
      this.formatNum(gameTime.getMinutes()) +
      ':' +
      this.formatNum(gameTime.getSeconds())
    );
  }

  formatNum(num: number): string {
    let returnStr = '';
    if (num < 10) {
      returnStr = '0' + num;
    } else {
      returnStr = '' + num;
    }
    return returnStr;
  }
}
